import React from 'react'
import { Helmet } from 'react-helmet-async'
import { MediaCollectionsLayout } from '../../layouts/MediaLibrary'

const MediaCollectionsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet titleTemplate="%s - ImageKit Media Library">
      <title>Media Collections</title>
      <meta name="description" content="Media Collections page" />
    </Helmet>
    <MediaCollectionsLayout />
  </React.Fragment>
)

export default MediaCollectionsPage
